import {IconButton} from '@wandb/components';
import {Trigger as DropdownTrigger} from '@wandb/weave/components/DropdownMenu';
import clsx from 'clsx';
import React from 'react';

type RunRowHeaderMenuTriggerProps = {
  /** What the trigger opens, for screen readers. Defaults to a run's menu. */
  ariaLabel?: string;
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  visible: boolean;
  onPrefetch?: () => void;
};

export function RowHeaderMenuTrigger(props: RunRowHeaderMenuTriggerProps) {
  const cls = clsx(
    'flex flex-col items-center',
    'transition-opacity duration-300',
    {'opacity-0': !props.visible}
  );

  return (
    <DropdownTrigger onClick={() => props.setMenuOpen(true)}>
      <div className={cls} onPointerEnter={props.onPrefetch}>
        <IconButton
          icon="overflow-horizontal"
          aria-label={props.ariaLabel ?? 'Show run menu'}
          variant="ghost"
          size="sm"
          isActive={props.menuOpen}
          onPress={e => {
            e.continuePropagation();
          }}
        />
      </div>
    </DropdownTrigger>
  );
}
